<template>
    <div>
        <!-- Single root element -->
        <v-textarea
            v-model="formInput"
            :label="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"
            dense
            outlined
            rounded
            :rows="$attrs.rows ? $attrs.rows : 3"
            :error-messages="errorMessage"
            background-color="#fff"
            :disabled="$attrs.readonly || $attrs.disabled"
            v-bind="$attrs"
            :class="printable ? 'd-print-none' : ''"
            @change="resetErrorMessage($event)"
            v-on="$listeners"
        >
            <template #label>
                <span v-html="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"></span>
            </template>
        </v-textarea>

        <div v-if="printable" class="d-none d-print-block">
            <!-- Shows when printable is true -->
            <label class="v-label v-label--active theme--light print-label">
                <span v-html="mandatory ? `${$root.defaultMandatoryAsteriks} ${label} ` : label"></span>
            </label>
            <div class="print-textarea">
                {{ formInput }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BInput',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
        printable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },
    computed: {
        formInput: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
            },
        },
        errorMessage() {
            return _.get(this.$store.state[this.store].errorMessages, this.propertyToMutate);
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
    methods: {
        resetErrorMessage() {
            if (this.errorMessage) {
                this.$store.commit(`${this.store}/SET_ERROR_MESSAGE`, {
                    value: [],
                    property: this.propertyToMutate,
                });
            }
        },
    },
};
</script>

<style>
.v-text-field .v-label {
    overflow: visible !important;
    white-space: normal !important;
}

.v-text-field .v-label--active {
    overflow: hidden !important;
    white-space: nowrap !important;
    max-width: 100% !important;
}
.print-textarea {
    gap: 1rem;
    flex-wrap: wrap;
    line-height: 1.75rem;
    text-indent: 0px;
    align-self: stretch;
    text-align: start;
    overflow-wrap: break-word;
    padding: 10px;
    border: 1px solid #000000;
    border-radius: 25px;
    background-color: rgb(249, 249, 249);
    color: #000000;
    font-size: 16px;
    margin-bottom: 20px;
}
.print-label {
    left: 0px;
    right: auto;
    position: relative;
    margin-bottom: 6px;
    display: block;
    font-size: 14px;
}
</style>
